import { DemoLight } from "../../buttons"
import hero from "../../images/help-hero.svg"

export default function HelpHero() {
  return (
    <>
      <section className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center xl:max-w-6xl xl:mx-auto py-10 lg:pt-48 lg:pb-20">
        <article>
          <h1 className="mb-1">Consistently Great Customer Service</h1>
          <p className="lg:text-2xl">
            We provide our clients with amazing support when it comes to their
            products. We ensure to supply the highest quality assistance for our
            clients to receive the best customer care experience from us. We
            strongly believe a “Happy customer is a customer for life”. We are
            proud to offer consistently excellent service.
          </p>
          <div className="mt-8 mb-10 lg:mb-0">
            <DemoLight />
          </div>
        </article>

        <article>
          <img
            src={hero}
            alt="Consistently Great Customer Service"
            title="Consistently Great Customer Service"
            className="block mx-auto"
          />
        </article>
      </section>
    </>
  )
}
